import { render } from "./CategoryList.vue?vue&type=template&id=ce80bc76"
import script from "./CategoryList.vue?vue&type=script&lang=js"
export * from "./CategoryList.vue?vue&type=script&lang=js"

import "./CategoryList.vue?vue&type=style&index=0&id=ce80bc76&lang=scss"

import exportComponent from "C:\\Programming\\VUE projects\\ELTECH\\eltech-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__